import React from "react";

export const nextGatewayTab = (items, current, key) => {
  const source = Array.isArray(items) ? items : [];
  if (!source.length) return current;
  const index = Math.max(0, source.findIndex((item) => item.id === current));
  if (key === "Home") return source[0].id;
  if (key === "End") return source[source.length - 1].id;
  if (key !== "ArrowLeft" && key !== "ArrowRight") return current;
  const offset = key === "ArrowRight" ? 1 : -1;
  return source[(index + offset + source.length) % source.length].id;
};

export default function GatewayTabs({
  items,
  active,
  onChange,
  ariaLabel = "Sections",
  className = "",
  tabClassName = "",
  idPrefix = "gateway-tab",
  panelIdPrefix = idPrefix,
  getSecondary,
}) {
  const select = (id, focus = false) => {
    onChange(id);
    if (focus) window.requestAnimationFrame(() => document.getElementById(`${idPrefix}-${id}`)?.focus());
  };
  return (
    <div className={`gwTabs${className ? ` ${className}` : ""}`} role="tablist" aria-label={ariaLabel}>
      {items.map((item) => {
        const selected = active === item.id;
        const secondary = getSecondary?.(item) || item.description || "";
        return (
          <button
            className={`gwTab${tabClassName ? ` ${tabClassName}` : ""}${selected ? " isActive" : ""}`}
            id={`${idPrefix}-${item.id}`}
            key={item.id}
            type="button"
            role="tab"
            aria-selected={selected}
            aria-controls={`${panelIdPrefix}-panel-${item.id}`}
            tabIndex={selected ? 0 : -1}
            disabled={item.disabled}
            onClick={() => select(item.id)}
            onKeyDown={(event) => {
              const next = nextGatewayTab(items, item.id, event.key);
              if (next === item.id) return;
              event.preventDefault();
              select(next, true);
            }}
          >
            <span>{item.label}</span>
            {secondary ? <small>{secondary}</small> : null}
          </button>
        );
      })}
    </div>
  );
}
